import { ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LazyRenderService {
  render<T>(viewContainerRef: ViewContainerRef, component: Type<T>): ComponentRef<T> {
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(component);
    componentRef.changeDetectorRef.detectChanges();
    return componentRef;
  }
}
